import React from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import messages from './messages';

export const pendingCustomsDocumentsOption = {
  id: 'pendingCustomsDocuments',
  displayName: <FormattedMessage {...messages.pendingCustomsDocuments} />,
  type: OptionFormTypes.TYPE_BOOLEAN,
  filterValue: 'PendingDocuments',
  render: (criteriaInformations: Record<string, unknown>) =>
    renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations),
};
